package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Asset(
  public val id: String,
  public val name: String,
  public val kind: String,
  public val currency: String,
  public val value_: Long?,
  public val purchase_price: Long?,
  public val acquired_date: String?,
  public val valued_at: String?,
  public val note: String?,
  public val archived: Long,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
